import { createContext } from 'react';

import { SupportedLocales } from '../../lib/api/types';

export type InterfaceSettingsModel = {
  activeLocale: SupportedLocales;
};

export const InterfaceSettingsContext = createContext<InterfaceSettingsModel>({
  activeLocale: SupportedLocales.ENGLISH_USA,
});
